import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import { useStyles } from '../../adminStyles';
import { notify } from '../../../../redux/utils/notifications/notifications';
import PropTypes from 'prop-types';
import MaskedInput from 'react-text-mask';
import {
  saveVendor,
  clearVendor,
  getSelectedVendor,
} from '../../../../redux/vendors/vendorActions';
import {
  Container,
  Grid,
  Checkbox,
  InputLabel,
  FormControlLabel,
  FormControl,
  Input,
  Button,
  Typography,
  TextField,
} from '@material-ui/core';

function TextMaskCustom(props) {
  const { inputRef, ...other } = props;

  return (
    <MaskedInput
      {...other}
      ref={ref => {
        inputRef(ref ? ref.inputElement : null);
      }}
      mask={[
        '1',
        '-',
        /[1-9]/,
        /\d/,
        /\d/,
        '-',
        /\d/,
        /\d/,
        /\d/,
        '-',
        /\d/,
        /\d/,
        /\d/,
        /\d/,
      ]}
      placeholderChar={'\u2000'}
      placeholder='1-555-555-5555'
    />
  );
}

TextMaskCustom.propTypes = {
  inputRef: PropTypes.func.isRequired,
};

const VendorDetails = props => {
  document.title = 'Sciata Vendor Details';

  const dispatch = useDispatch();
  const vendor = useSelector(state => state.vendorsList.selectedVendor || {});
  const [vendorId, setVendorId] = useState(0);
  const [record, setRecord] = useState({});
  const { root, container } = useStyles();
  useEffect(() => {
    let vid = 0;
    let _record = { ...record };
    _record['isActive'] = true;
    setRecord(_record);
    try {
      vid = parseInt(props.match.params.vid);
    } catch (e) {
      vid = 0;
    }
    setVendorId(vid);
    bindVendor(vid);
  }, []);
  const bindVendor = id => {
    dispatch(getSelectedVendor(id));
  };
  useEffect(() => {
    if (vendorId <= 0) {
    } else {
      setRecord(vendor);
    }
  }, [vendor]);

  const onFieldChange = e => {
    let _record = { ...record };
    _record[e.target.name] = e.target.value;
    setRecord(_record);
  };
  const handleSave = async () => {
    if (!validateForm()) {
      return false;
    }
    let body = JSON.parse(JSON.stringify(record));
    body['vendorId'] = vendorId;
    const result = await dispatch(saveVendor(body, vendorId));
    if (result) {
      dispatch(clearVendor());
      props.history.push('/admin/vendors');
    }
  };
  const validateForm = () => {
    if ((record.vendorName || '').trim().length <= 0) {
      notify('error', 'Please enter vendor name');
      return false;
    }
    if ((record.vendorEmail || '').trim().length <= 0) {
      notify('error', 'Please enter email id');
      return false;
    }
    if ((record.contactPName || '').trim().length <= 0) {
      notify('error', 'Please enter contact person name');
      return false;
    }

    if ((record.phone || '').trim().length <= 0) {
      notify('error', 'Please enter phone number');
      return false;
    }
    if ((record.website || '').trim().length <= 0) {
      notify('error', 'Please enter website name');
      return false;
    }
    return true;
  };

  return (
    <Container className={container}>
      <Grid style={{ marginTop: '100px' }}>
        <Typography variant='h6' gutterBottom>
          Vendor Details
        </Typography>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={12}>
            <Grid container spacing={3}>
              <Grid item xs={12} sm={4}>
                <TextField
                  required
                  id='vendorName'
                  name='vendorName'
                  label='Vendor Name'
                  fullWidth
                  value={record.vendorName || ''}
                  onChange={onFieldChange}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  required
                  id='vendorEmail'
                  name='vendorEmail'
                  label='Email Id'
                  fullWidth
                  autoComplete='vendorEmail'
                  value={record.vendorEmail || ''}
                  onChange={onFieldChange}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  required
                  id='contactPName'
                  name='contactPName'
                  label='Contact Person Name'
                  fullWidth
                  autoComplete='contactPName'
                  value={record.contactPName || ''}
                  onChange={onFieldChange}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  id='addressLine1'
                  name='addressLine1'
                  label='Address Line1'
                  fullWidth
                  autoComplete='addressLine1'
                  value={record.addressLine1 || ''}
                  onChange={onFieldChange}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  id='addressLine2'
                  name='addressLine2'
                  label='Address Line2'
                  fullWidth
                  autoComplete='addressLine2'
                  value={record.addressLine2 || ''}
                  onChange={onFieldChange}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  id='addressCity'
                  name='addressCity'
                  label='City'
                  fullWidth
                  autoComplete='addressCity'
                  value={record.addressCity || ''}
                  onChange={onFieldChange}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  id='addressState'
                  name='addressState'
                  label='State'
                  fullWidth
                  value={record.addressState || ''}
                  onChange={onFieldChange}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  id='addressZip'
                  name='addressZip'
                  label='Zip'
                  fullWidth
                  autoComplete='addressZip'
                  value={record.addressZip || ''}
                  onChange={onFieldChange}
                />
              </Grid>

              <Grid item xs={12} sm={4}>
                <FormControl fullWidth>
                  <InputLabel htmlFor='mobile-text-mask-input' required>
                    Phone
                  </InputLabel>
                  <Input
                    id='mobile-text-mask-input'
                    name='phone'
                    label='Phone'
                    value={record.phone || ''}
                    inputComponent={TextMaskCustom}
                    onChange={onFieldChange}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  id='fax'
                  name='fax'
                  label='Fax'
                  fullWidth
                  autoComplete='fax'
                  value={record.fax || ''}
                  onChange={onFieldChange}
                />
              </Grid>
              <Grid item xs={12} sm={4}>
                <TextField
                  required
                  id='website'
                  name='website'
                  label='Website'
                  fullWidth
                  autoComplete='website'
                  value={record.website || ''}
                  onChange={onFieldChange}
                />
              </Grid>
              <Grid item xs={4}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={record.isActive ? true : false}
                      name='active'
                      onChange={e => {
                        let _record = { ...record };
                        _record['isActive'] = e.target.checked ? true : false;
                        setRecord(_record);
                      }}
                      color='primary'
                    />
                  }
                  label={'Active'}
                />
              </Grid>
              <Grid item xs={12} align='right'>
                <Button
                  variant='contained'
                  color='secondary'
                  style={{ marginRight: '10px' }}
                  onClick={() => {
                    dispatch(clearVendor());
                    props.history.push('/admin/vendors');
                  }}
                >
                  Cancel
                </Button>
                <Button variant='contained' color='primary' onClick={handleSave}>
                  Save
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Container>
  );
};

export default withRouter(VendorDetails);
